import { useDispatch, useSelector } from 'react-redux';

import { RootState } from 'app/appStore';

import { setCollapsed, toggleCollapsed, toggleOpened } from '../model/sidebarSlice';

export const useSidebarSlice = () => {
	const dispatch = useDispatch();

	return {
		...useSelector((s: RootState) => s.sidebarReducer),
		toggleCollapsed: () => dispatch(toggleCollapsed()),
		setCollapsed: (collapsed: boolean) => dispatch(setCollapsed(collapsed)),
		toggleOpened: (isClose?: boolean) => dispatch(toggleOpened(isClose)),
	};
};
